module.exports = __webpack_public_path__ + "media/images/bg_image/signup_bg-04f058f92e21f4fcf7a0fc05e6dab177.png";